import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Session lives only in the httpOnly cookie; clear any legacy stored token
localStorage.removeItem("agh_token");

export const formatError = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Something went wrong";
};

export const getImageSrc = (product) => {
  if (product?.image_path) return `${API}/files/${product.image_path}`;
  if (product?.external_image) return product.external_image;
  return "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?w=800&q=80";
};
